// ---------------------------------------------------------------------------
// core/i18n — Barrel export for internationalization infrastructure
// ---------------------------------------------------------------------------

export {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  RTL_LOCALES,
  LOCALE_MAP,
  LOCALE_STORAGE_KEY,
  isSupportedLocale,
  getLocaleDir,
} from './i18n.config';
export type { SupportedLocale, LocaleConfig } from './i18n.config';

export { useTranslation } from './useTranslation';
export type { UseTranslationReturn } from './useTranslation';

export { LanguageSelector } from './LanguageSelector';
export { LocaleLink, useLocaleHref } from './LocaleLink';
export { LocaleContext, useLocaleContext } from './locale.context';
